
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';
import './App.css';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { ToastContainer } from "react-toastify";
import LiquidEther from './components/LiquidEther';
import "react-toastify/dist/ReactToastify.css"; // Ensure the CSS is imported
import logo from './Assets/magi.png';
import { loginRequest } from './authConfig';

import CorporateDataPage from './Pages/CorporateDataPage';
import InvoicePage from './Pages/InvoicePage';
import ScrollToTop from './components/Common/ScrollToTop';




function SignInScreen() {
  const { instance, inProgress } = useMsal();
  const [loading, setLoading] = useState(false);

  const onSignIn = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });
  };

  const handleClick = () => {
    if (inProgress !== 'none') {
      return;
    }
    setLoading(true);
    // The login redirect will take over, but we set loading state
    // in case there's a delay or popup blocker.
    onSignIn();
  };

  return (
    <div className="signin">
      <div style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', zIndex: 1, pointerEvents: 'none' }}>
        <LiquidEther
          colors={[ '#f25a4b', '#1f94ed', '#6390b4' ]}
          mouseForce={20}
          cursorSize={100}
          isViscous={true}
          viscous={30}
          iterationsViscous={32}
          iterationsPoisson={32}
          resolution={0.5}
          isBounce={false}
          autoDemo={true}
          autoSpeed={0.5}
          autoIntensity={2.2}
          takeoverDuration={0.25}
          autoResumeDelay={3000}
          autoRampDuration={0.6}
        />
      </div>

      <div className="signin__hero-container">
        <div className="signin__hero-left">
          <div className="signin__eyebrow-badge">
            <span className="signin__status-dot" />
            <span>Enterprise Client Platform</span>
          </div>

          <h1 className="signin__hero-title">
            Magizhini Tech
          </h1>

          <p className="signin__hero-subtitle">
            Enterprise client tracking, automated invoice workflow, and real-time financial reporting platform.
          </p>

          <div className="signin__hero-grid">
            <div className="signin__hero-card">
              <div className="signin__hero-card-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
              </div>
              <div className="signin__hero-card-content">
                <h4>Clients</h4>
                <p>Track tax progress & status</p>
              </div>
            </div>

            <div className="signin__hero-card">
              <div className="signin__hero-card-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <line x1="2" y1="10" x2="22" y2="10" />
                </svg>
              </div>
              <div className="signin__hero-card-content">
                <h4>Invoice System</h4>
                <p>Manage client billing & receipts</p>
              </div>
            </div>

            <div className="signin__hero-card">
              <div className="signin__hero-card-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div className="signin__hero-card-content">
                <h4>Client Portal</h4>
                <p>Secure document & review hub</p>
              </div>
            </div>

            <div className="signin__hero-card">
              <div className="signin__hero-card-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="20" x2="18" y2="10" />
                  <line x1="12" y1="20" x2="12" y2="4" />
                  <line x1="6" y1="20" x2="6" y2="14" />
                </svg>
              </div>
              <div className="signin__hero-card-content">
                <h4>Analytics</h4>
                <p>Real-time insights & reporting</p>
              </div>
            </div>
          </div>
        </div>

        <div className="signin__hero-right">
          <div className="signin__card">
            <div className="signin__card-header">
              <img src={logo} alt="Magizhini Technology Services Inc." className="signin__logo" style={{ maxHeight: '60px', objectFit: 'contain' }} />
            </div>

            <div className="signin__card-body">
              <h3 className="signin__card-title">Account Access</h3>
              <p className="signin__card-subtitle">
                Sign in with your organization Microsoft account to continue.
              </p>

              <button className="ms-signin-btn" onClick={handleClick} disabled={loading}>
                {loading ? (
                  <span className="ms-signin-btn__spinner" />
                ) : (
                  <svg width="18" height="18" viewBox="0 0 21 21" aria-hidden="true">
                    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
                  </svg>
                )}
                {loading ? 'Signing in…' : 'Sign in with Microsoft'}
              </button>

              <div className="signin__card-footer">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="4" y="11" width="16" height="9" rx="2" />
                  <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                </svg>
                <span>Secured by Microsoft 365 Enterprise Sign-In</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function App() {
  // This hook handles the redirect flow and ensures MSAL is initialized.
  // It will automatically call handleRedirectPromise and set the active account.
  // This simplifies the logic and prevents the "interaction_in_progress" error.
  useMsalAuthentication(loginRequest);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      <PullToRefresh onRefresh={handleRefresh}>
        <BrowserRouter>
          <AuthenticatedTemplate>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<CorporateDataPage />} />
              <Route path='/landing' element={<CorporateDataPage />} />
              <Route path='/corporateData' element={<CorporateDataPage />} />
              <Route path='/invoice' element={<InvoicePage />} />
              <Route path="*" element={<Navigate to="/corporateData" replace />} />
            </Routes>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<SignInScreen />} />

              {/* Redirect any other unauthenticated access back to the sign-in page */}
              <Route path="*" element={<SignInScreen />} />
            </Routes>
          </UnauthenticatedTemplate>
        </BrowserRouter>
      </PullToRefresh>
      <ToastContainer />
    </>
  );
}

export default App;
